export default __webpack_public_path__ + "static/media/rm-logo-small.0b49eb2c.svg";